import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useLogout } from "@core/features/auth";
import { usePlatformStore } from "@platform/store";
import { Type } from "@themes/pollinator/ui/Type";

export function LogoutPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const clearAuth = usePlatformStore((s) => s.clearAuth);

  const handleSuccess = () => {
    startTransition(() => {
      queryClient.clear();
      clearAuth();
      navigate("/login");
    });
  };

  const handleError = () => {
    navigate("/login");
  };

  useLogout({
    onSuccess: handleSuccess,
    onError: handleError,
    autoLogout: true,
  });

  return (
    <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
      <div className="flex flex-1 flex-col items-center justify-center">
        <Type as="h1" variant="h3">
          Logging out...
        </Type>
      </div>
    </div>
  );
}

export default LogoutPage;


